import { Attributes, DateUtils, List, NeoModel } from "@singularsystems/neo-core";
import { injectable } from "inversify";
import { AppService, DomainTypes } from "../DomainTypes";
import IssuerInvestmentLookup from "../Models/IssuerInvestments/Lookups/IssuerInvestmentLookup";

/**
 * Cache helper for issuer investments.
 * 
 * For some tenants that only have a few issuer investments, this service allows the issuer investment drop down to immediately show a list of investments,
 * rather than the user having to start typing in an issuer name.
 */
@injectable()
@NeoModel
export default class IssuerInvestmentCache {

    constructor(private issuerInvestmentApiClient = AppService.get(DomainTypes.ApiClients.IssuerInvestment)) {

    }

    @Attributes.Observable()
    public parentIssuerInvestments = new List(IssuerInvestmentLookup);

    private lastFetchDate: Date | null = null;

    /**
     * Updates the cached investments if fetch has not been performed in the last minute.
     */
    public async updateParentInvestments(force: boolean = false) {

        const canFetch = this.parentIssuerInvestments.length > 0 || this.lastFetchDate === null;
        const hasExpired = this.lastFetchDate === null || DateUtils.difference(this.lastFetchDate, new Date()).totalMinutes > 1;

        if ((canFetch && hasExpired) || force) {
            this.lastFetchDate = new Date();

            const response = await this.issuerInvestmentApiClient.getCachedParentIssuerInvestments();
            this.parentIssuerInvestments.set(response.data);
        }
    }

    public reset() {
        this.lastFetchDate = null;
    }
}